import Login from '../components/Login';

const Page = () => <Login />;

export default Page;
